import { Component, inject, OnInit, signal, ViewChild, ElementRef } from '@angular/core';
import { User } from './model/user';
import { Auth } from './services/auth';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs';
import { Master } from './services/master';
import { QuestionState } from './services/question-state';
import { GtmService } from './services/gtm-service';

declare global {
  interface Window {
    dataLayer: any[];
  }
}

@Component({
  selector: 'app-root',
  templateUrl: './app.html',
  standalone: false,
  styleUrl: './app.less'
})
export class App implements OnInit {
  @ViewChild('mainContent') mainContent!: ElementRef;
  user?: User | null;
  hideHeader: boolean = false;
  private masterService = inject(Master);
  private questionState = inject(QuestionState);
  tradeHistory: any[] = [];
  rowNum: any = 0;
  size: any = 10;
  chatHistory: {
    question: '',
    answer: ''

  }[] = [];

  protected readonly title = signal('agrify-ui');
  constructor(private accountService: Auth,
    private gtmService : GtmService,
    private router: Router
  ) {
    this.accountService.user.subscribe(x => this.user = x);
    console.log('isInRole ' + this.isInRole(['ADMIN', 'SUPERADMIN']));

    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        const hiddenRoutes = ['', '/login', '/registration'];
        const url = event.urlAfterRedirects;
        this.hideHeader = hiddenRoutes.some(route =>
          url.includes(route)
        );
        if (this.mainContent) {
          this.mainContent.nativeElement.scrollTop = 0;
        }
        this.gtmService.pushPageView(url);

      });

  }

  ngOnInit(): void {
    // this.getTradeGPTHistory(this.rowNum,this.size);
    this.questionState.setChatHistory({ test: 'Hello from AppComponent' });
  }

  logout() {
    this.accountService.logout();
  }

  isInRole(privileges: string[]) {
    const cc = this.user?.privileges?.filter(x => privileges.includes(x));
    if (cc != undefined && cc?.length > 0) {
      return true;
    } else {
      return false;
    }

  }

  getTradeGPTHistory(rowNum: any, size: any) {
    this.masterService.getTradeGPTHistory(rowNum, size).
      subscribe({
        next: (data: any) => {
          this.tradeHistory = data.rows;
          console.log(this.tradeHistory);
          this.generateHistoryRecord(this.tradeHistory);
          console.log(this.tradeHistory);
        }
      })
  }



  showHistory: boolean = false;

  onToggleHistory() {
    this.showHistory = !this.showHistory;
    if (this.showHistory) {
      this.getTradeGPTHistory(this.rowNum, this.size);
    }
  }

  selectHistoryItem(item: any) {
    this.showHistory = false;
    
    if (!this.router.url.includes('/trade-gpt')) {
      this.router.navigate(['/trade-gpt']).then(() => {
        this.questionState.setQuestion(item);
      });
    } else {
      this.questionState.setQuestion(item);
    }
  }

  generateHistoryRecord(tradeHistory: any) {
    console.log(tradeHistory.length);
    this.chatHistory = [];
    for (let i = 0; i < tradeHistory.length; i += 2) {
      this.chatHistory.push({
        answer: tradeHistory[i].chat || null,
        question: tradeHistory[i + 1].chat || null
      });
    }
    console.log(this.chatHistory);
  }


}
